import { type Notification } from '@atlassian/notification-types/types';

declare global {
	interface Window {
		__backendOriginHost: string | undefined;
	}
}

// checks if the current page is the same as the notification content
export const isViewingNotifContent = (notification: Notification): boolean => {
	const notificationUrl = getNotifUrl(notification);

	if (!notificationUrl) {
		// err on side of assuming we are not on the same content
		// as the notification when we can't parse notification link
		return false;
	}

	const { location: currentLocation } = window;
	const currentHostname = getCurrentHostname(currentLocation.hostname); // handles localhost

	if (currentHostname !== notificationUrl.hostname) {
		return false;
	}

	const currentPathname = currentLocation.pathname;
	const notifPathname = notificationUrl.pathname;

	if (currentPathname === notifPathname) {
		return true;
	}

	// pathname with and without content title are still the same content
	// this check is a naive way of checking if removing the last path segment
	// (possibly the title) will make the paths equal
	if (currentPathname.length > notifPathname.length) {
		return removeLastPathSegment(currentPathname) === notifPathname;
	}

	if (notifPathname.length > currentPathname.length) {
		return removeLastPathSegment(notifPathname) === currentPathname;
	}

	return false;
};

const getNotifUrl = (notification: Notification): URL | null => {
	try {
		const urlString = notification?.content?.entity?.link?.url ?? '';
		return new URL(urlString);
	} catch (e) {
		return null;
	}
};

const removeLastPathSegment = (url: string): string => {
	const urlParts = url.split('/');
	urlParts.pop();
	return urlParts.join('/');
};

function getCurrentHostname(hostname: string): string {
	return hostname === 'localhost' ? getLocalhostBackendUrl() : hostname;
}

function getLocalhostBackendUrl() {
	return window.__backendOriginHost ? `${window.__backendOriginHost}` : 'pug.jira-dev.com';
}
